// English message translations
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "This answer was shortened because it reached the length limit and may be incomplete.",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.",
  // Common UI elements
  "Send": "Send",
  "Clear chat": "Clear chat",
  "Support": "Support",
  "Settings": "Settings",
  "Language": "Language",
  "Theme": "Theme",
  "Font Size": "Font Size",
  "Select language": "Select language",
  
  // Chat interface
  "Type your message...": "Type your message...",
  "Thinking...": "Thinking...",
  "Ministry of Commerce Laws Expert": "MoC Laws Expert",
  "by MJ": "by MJ",
  "Mila": "Mila",
  
  // Frameworks
  "Automatic detection": "Automatic detection",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "A1. Companies Law",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "A2. Professional Companies Law",
  "MOC_COMMERCIAL_REGISTER_LAW": "A3. Commercial Register Law",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "A4. Ministry of Commerce Law",
  "MOC_TRADE_NAMES_LAW": "A5. Trade Names Law",
  "MOC_GCC_TRADEMARK_LAW": "A6. GCC Trademark Law",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "B1. Commercial Papers Law",
  "MOC_COMMERCIAL_PLEDGE_LAW": "B2. Commercial Pledge Law",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "B3. Movable Property Security Law",
  "MOC_INSOLVENCY_LAW": "B4. Insolvency Law",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "C1. Commercial Agencies Law",
  "MOC_FRANCHISE_LAW": "C2. Franchise Law",
  "MOC_ECOMMERCE_LAW": "C3. E-Commerce Law",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "C4. Chambers of Commerce Law",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "D1. Commercial Books Law",
  "MOC_COMMERCIAL_DATA_LAW": "D2. Commercial Data Law",
  "MOC_PUBLIC_WAREHOUSING_LAW": "D3. Public Warehousing Law",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "E1. Standards and Metrology Law",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "E2. Calibration and Measurement Law",
  "MOC_PRIVATE_LABORATORIES_LAW": "E3. Private Laboratories Law",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "E4. Precious Metals and Gemstones Law",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "E5. Chemicals Import Management Law",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "F1. Accounting and Auditing Law",
  "MOC_VALUERS_LAW": "F2. Valuers Law",
  "MOC_ENGINEERS_LAW": "F3. Engineers Law",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "G1. Anti-Concealment Law",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "G2. Anti-Money Laundering Law",
  "MOC_ARBITRATION_LAW": "G3. Arbitration Law",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "G4. Combating Commercial Adulteration Law",
  "MOC_GCC_COMBATING_DUMPING_LAW": "G5. GCC Anti-Dumping Law",
  
  // Models
  "Claude by Anthropic": "Claude by Anthropic",
  "DeepSeek by Groq": "DeepSeek by Groq",
  "MJ Lab Mode": "MJ Lab Mode",
  
  // Messages
  "Language changed to {{locale}}": "Language changed to {{locale}}",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Hello, I am {{name}}, an AI assistant made by MJ.",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.": "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.",
  "Ask me a question, and I will gladly answer you.": "Ask me a question, and I will gladly answer you.",
  "Do not share confidential data.": "Do not share confidential data.",
  "I am powered using": "I am powered using",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Disclaimer:** {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.",
  
  // Error messages
  "An error occurred": "An error occurred",
  "Failed to change language": "Failed to change language",
  "Please try again": "Please try again",
  "Connection lost": "Connection lost",
  "Reconnecting...": "Reconnecting...",
  "Nothing to clear": "Nothing to clear",
  "All messages cleared": "All messages cleared",
  "All data cleared": "All data cleared",
  "Storage limit reached": "Storage limit reached",
  "Some older messages were removed to save space.": "Some older messages were removed to save space.",
  "Error": "Error",
  
  // Tooltips
  "Increase font size": "Increase font size",
  "Decrease font size": "Decrease font size",
  "Reset font size": "Reset font size",
  "Change theme": "Change theme",
  "Support the project": "Support the project",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} character left",
  "{{remainingChars}} characters left": "{{remainingChars}} characters left",
  
  // Message actions
  "Message copied to clipboard": "Message copied to clipboard",
  "Read": "Read",
  "Summarize": "Summarize",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Message Suggestions",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.": "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?": "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?": "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?", 
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?": "What protections does the Saudi E-commerce Law provide for online consumers and businesses?",
  
  // Audio Player Dialog
  "AI Summary": "AI Summary",
  "Listen to the summarized response using our AI Service.": "Listen to the summarized response using our AI Service.",
  "Generating summary...": "Generating summary...",
  "Preparing audio...": "Preparing audio...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Failed to process text. Please try again.",
  "Failed to auto-play audio. Click play to try again.": "Failed to auto-play audio. Click play to try again.",
  "Failed to load audio. Please try again.": "Failed to load audio. Please try again.",
  "Audio playback was aborted.": "Audio playback was aborted.",
  "Network error occurred while loading audio.": "Network error occurred while loading audio.",
  "Audio decoding failed.": "Audio decoding failed.",
  "Audio format not supported.": "Audio format not supported.",
  "Failed to setup audio playback": "Failed to setup audio playback",
  "Failed to generate speech": "Failed to generate speech",
  "Failed to generate audio. Please try again.": "Failed to generate audio. Please try again.",
  "Failed to play audio. Please try again.": "Failed to play audio. Please try again.",
  
  // Update Notifications
  "update.updateAvailable": "Update Available",
  "update.newVersionAvailable": "New Version {{version}} Available",
  "update.refreshToApply": "Refresh to apply the latest features and improvements",
  "update.later": "Later",
  "update.updateNow": "Update Now"
};
